import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { RESOURCE_STATES, LIVE_STATES } from '../constants';

const ResourceStatePill = ({ state }) => {
  if (!state) {
    return null;
  }
  return (
    <div
      className={cx(
        'rounded-full text-xs px-2 leading-loose tracking-wide inline-block',
        {
          'bg-lightYellow': state === RESOURCE_STATES.UNSAVED,
          'bg-lightBlue': state === RESOURCE_STATES.DRAFT,
          'bg-lightGreen': state === RESOURCE_STATES.PUBLISHED || state === LIVE_STATES.ONLINE,
          'bg-lightRed': state === LIVE_STATES.OFFLINE,
        }
      )}>
      {state}
    </div>
  );
};

ResourceStatePill.propTypes = {
  state: PropTypes.string.isRequired,
};

export default  ResourceStatePill;
